import classNames from "classnames";
import { FundItemListDonation } from "./FundItemListDonation";
import { FundItemListImage } from "./FundItemListImage";

interface FundItemListProps {
  ein: string;
  name: string;
  imageId?: number;
  donationWeight: number;
  description?: string;
}

export function FundItemList({
  ein,
  name,
  imageId,
  donationWeight,
  description,
}: FundItemListProps) {
  return (
    <div
      onClick={() => {
        window.location.href = `/ein/${ein}`;
      }}
      className={classNames(
        "tw:min-w-[300px] tw:my-4 tw:md:my-0 tw:block tw:w-full tw:bg-white tw:!border-t tw:!border-t-gray-300/60 tw:p-0 tw:md:p-5 tw:hover:cursor-pointer",
        "tw:flex tw:flex-row tw:justify-between tw:items-center tw:h-full tw:gap-4",
      )}
      aria-label="nonprofit profile page"
    >
      <>
        <FundItemListImage imageId={imageId} />

        <div className="tw:flex tw:flex-col tw:justify-start tw:w-full">
          <div className="tw:mt-0 tw:font-semibold tw:text-xl tw:md:text-3xl tw:text-cn-search tw:mb-4">
            {name}
          </div>

          <div className="ttw:my-4 tw:text-[#49516f] tw:text-sm tw:md:text-md tw:leading-relaxed">
            {description || ""}
          </div>
        </div>

        <FundItemListDonation donationWeight={donationWeight} />
      </>
    </div>
  );
}
